// Compteur de test « Plus de N personnes… » : +1 toutes les N secondes, remis à la valeur de départ
// toutes les N heures (data-cycle), avec une transition
// façon compteur (l'ancien nombre monte et s'efface, le nouveau arrive par le bas).
// Le point de départ est mémorisé pour la visite : la valeur ne repart pas de zéro quand le bloc
// est re-rendu (changement de variante) ou que la page est rechargée.
if (!customElements.get('mp-compteur-panier')) {
  class MpCompteurPanier extends HTMLElement {
    connectedCallback() {
      this.depart = Number(this.dataset.depart) || 0;
      this.intervalle = (Number(this.dataset.intervalle) || 20) * 1000;
      this.cycle = (Number(this.dataset.cycle) || 10) * 3600000;
      this.debut = this.lireDebut();
      this.valeur = this.calculer();
      this.querySelector('.mp-compteur__valeur').textContent = this.valeur;
      this.minuteur = setInterval(() => this.verifier(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.minuteur);
    }

    lireDebut() {
      const cle = 'mp-compteur-panier-debut';
      let debut = 0;
      try {
        debut = Number(sessionStorage.getItem(cle)) || 0;
      } catch {}
      if (!debut) {
        debut = Date.now();
        try {
          sessionStorage.setItem(cle, String(debut));
        } catch {}
      }
      return debut;
    }

    // Repart de la valeur de départ à chaque fin de cycle (10 h par défaut)
    calculer() {
      if (Date.now() - this.debut >= this.cycle) {
        this.debut = Date.now();
        try {
          sessionStorage.setItem('mp-compteur-panier-debut', String(this.debut));
        } catch {}
      }
      return this.depart + Math.floor((Date.now() - this.debut) / this.intervalle);
    }

    verifier() {
      const suivante = this.calculer();
      if (suivante !== this.valeur) this.afficher(suivante);
    }

    afficher(valeur) {
      this.valeur = valeur;
      const ancienne = this.querySelector('.mp-compteur__valeur.is-active');
      const nouvelle = document.createElement('span');
      nouvelle.className = 'mp-compteur__valeur is-entrante';
      nouvelle.textContent = valeur;
      this.appendChild(nouvelle);
      nouvelle.getBoundingClientRect();
      nouvelle.classList.replace('is-entrante', 'is-active');
      if (ancienne) {
        ancienne.classList.replace('is-active', 'is-sortante');
        ancienne.setAttribute('aria-hidden', 'true');
        setTimeout(() => ancienne.remove(), 700);
      }
    }
  }

  customElements.define('mp-compteur-panier', MpCompteurPanier);
}
